import { useState } from "react";

import { AlertV4, ButtonV4, FieldV4, ModalV4 } from "../common/ui";

import type { CancelReceiptData } from "../common/sequence/BillingHistoryV4";
import type { Receipt } from "./billingHistoryModelV4";

// Types
type ModalBillingCancelReceiptV4Props = {
  // data
  receipt: Receipt;
  reasonOptions?: { key?: string | number; value: string; text: string }[];
  busy?: boolean;
  error?: unknown;
  // callback
  onConfirm: (data: CancelReceiptData) => void;
  onClose: () => void;
};

/** ยืนยันยกเลิกใบเสร็จ: Username / Password ผู้ยืนยัน + เหตุผล */
const ModalBillingCancelReceiptV4 = (props: ModalBillingCancelReceiptV4Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [note, setNote] = useState("");

  // Handler
  const handleConfirm = () => {
    props.onConfirm({ username: username.trim(), password, note });
  };

  // Render
  return (
    <ModalV4 title="ยกเลิกใบเสร็จ" width={520} tone="danger" onClose={props.onClose}>
      <div className="hv4-bill-hist-modal">
        <div className="hv4-bill-hist-modal-sub">
          {props.receipt.code} · Encounter {props.receipt.encounter_no}
        </div>
        <FieldV4 label="Username *" htmlFor="hv4_bill_cancel_user">
          <input
            id="hv4_bill_cancel_user"
            className="hv4-input"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </FieldV4>
        <FieldV4 label="Password *" htmlFor="hv4_bill_cancel_password">
          <input
            id="hv4_bill_cancel_password"
            type="password"
            className="hv4-input"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FieldV4>
        <FieldV4 label="เหตุผลการยกเลิกใบเสร็จ *" htmlFor="hv4_bill_cancel_note">
          <select
            id="hv4_bill_cancel_note"
            className="hv4-input"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          >
            <option value="">— เลือกเหตุผล —</option>
            {(props.reasonOptions ?? []).map((option) => (
              <option key={option.key ?? option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
        </FieldV4>
        <AlertV4 tone="danger" error={props.error} />
        <div className="hv4-bill-hist-modal-foot">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            ไม่ยกเลิก
          </ButtonV4>
          <ButtonV4
            variant="danger"
            disabled={props.busy || !username.trim() || !password || !note}
            onClick={handleConfirm}
          >
            ยืนยันยกเลิกใบเสร็จ
          </ButtonV4>
        </div>
      </div>
    </ModalV4>
  );
};

ModalBillingCancelReceiptV4.displayName = "ModalBillingCancelReceiptV4";

export default ModalBillingCancelReceiptV4;
